<div class="modal-popup">
    <div class="modal-popup-content" [ngClass]="{ 'custom-zindex-popup':  custom }">
        <ng-content></ng-content>
    </div>
    <div class="modal-popup-overlay" [ngClass]="{ 'custom-zindex-overlay':  custom }">
    </div>
</div>